import constants from "../../../core/constants";
import isNil from "lodash/fp/isNil";
class Controller {
  constructor($mdDialog, $injector, availableStations, ride) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.User = $injector.get("User");
    this.Events = $injector.get("Events");
    this.Lists = $injector.get("Lists").all;

    this.ride = ride;
    this.stations = availableStations;
    this.paymentOptions = this.Lists.paymentOptions;
    this.ridePrice = this.ride.priceNum.value;
    this.corporateId = isNil(this.ride.corporates[0])
      ? undefined
      : this.ride.corporates[0]._id;
    this.selectUserEvent = this.Events.getSelectUserEvent();
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.Events.on(this.selectUserEvent, this.onSelectUser.bind(this));
    this.seats = 1;
  }

  onSelectUser(selectedUser) {
    const addCard = (cardData) => {
      const title = `${cardData.card.card_subtype} Card ${cardData.card.masked_pan}`;
      const value = "card";
      const id = cardData.card._id;

      return { title, value, id };
    };
    const getCreditPayment = (balance) => {
      return balance >= this.ridePrice ? { title: "Credits Only" } : null;
    };

    if (selectedUser) {
      this.User.get(selectedUser._id).$promise.then(
        (response) => {
          this.userData = response;
          this.userCredit =
            this.userData.balance.creditAmount / constants.currencyBy;

          const additionalPayments = this.userData.payments.map(addCard);
          const creditPayement = getCreditPayment(
            this.userData.balance.creditAmount
          );
          this.paymentOptions.push(...additionalPayments);

          if (creditPayement) this.paymentOptions.push(creditPayement);
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    }
  }

  confirm() {
    if (this.pickup && this.dropoff) {
      const user = this.user._id;
      const pickUp = this.pickup;
      const dropOff = this.dropoff;
      const promotion = this.promotion;
      const price = this.price ? this.price * constants.currencyBy : this.price;
      const payment = { method: "cash" };
      const seatsCount = this.seats;

      this.$mdDialog.hide({
        user,
        price,
        payment,
        promotion_code: promotion,
        pick_up: pickUp,
        drop_off: dropOff,
        seat_count: seatsCount,
      });
    }
  }

  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/bookDialog/bookDialog.controller.js